import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { consultants, CONSULTANT_DRAFT_NOTICE } from '../../data/consultants';
import { PageHero } from '../../components/ui/PageHero';
import { ConsultantCard } from '../../components/consultants/ConsultantCard';
import { CtaBand } from '../../components/ui/CtaBand';
export function Consultants() {
  usePageMeta('Meet Our Consultants', 'Meet the Corventa Talent Search executive search consultants.');
  return <>
      <PageHero crumbs={[{
      label: 'Our Consultants'
    }]} kicker="Our consultants" title="The people behind every search." intro="Every Corventa engagement is led personally by an executive search consultant, from first briefing to final appointment." data-id="element-863" data-mp="249436ttqj7ud" />
      <section className="bg-ivory py-20" data-id="element-864" data-mp="3tnsd8oeusdp8">
        <div className="container-page" data-id="element-865" data-mp="3tmplke9pi789">
          <p className="rounded-md border border-gold/40 bg-gold-100 px-4 py-3 text-sm text-gold-700" data-id="element-866" data-mp="3tlelopjdtjmf">{CONSULTANT_DRAFT_NOTICE}</p>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-867" data-mp="3s4qfq18bh8od">
            {consultants.map(c => <ConsultantCard key={c.slug} consultant={c} data-id="element-868" data-mp="1002lbv48slx" />)}
          </div>
        </div>
      </section>
      <CtaBand title="Speak with a consultant." text="Tell us about your search or your career, and we will connect you with the right person." primary={{
      label: 'Contact us',
      to: '/contact'
    }} secondary={{
      label: 'Our process',
      to: '/process'
    }} data-id="element-869" data-mp="3i8djavle0gpx" />
    </>;
}